import { apiClient } from "@/lib/api-client";

export const putPilihIku = async (
  niu: string,
  payload: {
    semester: string;
    tahun: string;
    selections: Record<
      string,
      {
        transfer_to: string | null;
        details: string[];
      }
    >;
  },
  baseUrlPath: string = "unsur-penelitian",
) => {
  const baseUrl = import.meta.env.VITE_API_BASE_URL;
  const data = await apiClient<any>(
    `${baseUrl}/api/v1/${baseUrlPath}/${niu}/pilih-iku`,
    {
      method: "PUT",
      body: JSON.stringify(payload),
    },
  );

  return data;
};
